import { useEffect, useState } from "react";
import { api } from "./api";

/** One shared read of `/settings/app`. Every FT-2 toggle defaults OFF until the admin turns it
 *  on, so a failed read must never look like "on". */
let cache = null;
let inflight = null;

export const invalidateAppSettings = () => { cache = null; inflight = null; };

export function useAppSettings() {
  const [settings, setSettings] = useState(cache);
  useEffect(() => {
    if (cache) { setSettings(cache); return undefined; }
    let alive = true;
    inflight = inflight || api.get("/settings/app").then(({ data }) => { cache = data; return data; })
      .catch(() => { inflight = null; return {}; });
    inflight.then((d) => { if (alive) setSettings(d); });
    return () => { alive = false; };
  }, []);
  return settings || {};
}
